var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09766 5.20093C2.54766 5.20093 2.09766 5.65093 2.09766 6.20093C2.09766 6.75093 2.54766 7.20093 3.09766 7.20093C3.64766 7.20093 4.09766 6.75093 4.09766 6.20093C4.09766 5.65093 3.64766 5.20093 3.09766 5.20093Z",
    fill: "#65676B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0977 5.20093C9.54766 5.20093 9.09766 5.65093 9.09766 6.20093C9.09766 6.75093 9.54766 7.20093 10.0977 7.20093C10.6477 7.20093 11.0977 6.75093 11.0977 6.20093C11.0977 5.65093 10.6477 5.20093 10.0977 5.20093Z",
    fill: "#65676B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59766 5.20093C6.04766 5.20093 5.59766 5.65093 5.59766 6.20093C5.59766 6.75093 6.04766 7.20093 6.59766 7.20093C7.14766 7.20093 7.59766 6.75093 7.59766 6.20093C7.59766 5.65093 7.14766 5.20093 6.59766 5.20093Z",
    fill: "#65676B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSettings);
export default __webpack_public_path__ + "static/media/youtubeSettings.4222f9cd.svg";
export { ForwardRef as ReactComponent };